import api from 'api'
import { AccountViewType, CustomerAccountWithLicenses } from 'types/CustomerAccountWithLicenses'
import fetchWithToken from './fetchWithToken'

const fetchCustomerAccounts = (partnerAccountKey: string): Promise<CustomerAccountWithLicenses[]> =>
  fetchWithToken({
    baseUrl: api.partnerAdminUrl,
    path: `accounts/${partnerAccountKey}/customers?view=${AccountViewType.ExtendedWithLicenses}&impersonationOnly=true`,
    useV5: false,
    useVersion: '',
    method: 'GET',
  }).then((response: Response) => response.json())

export default fetchCustomerAccounts
